<template>
  <div >
  <landing></landing>
  <section-2nd></section-2nd>
  <section-3rd></section-3rd>
  <section-4th></section-4th>
  <section-5th></section-5th>
  <section-6th></section-6th>
  <section-7th></section-7th>
  <section-8th></section-8th>
  <chaldalFaq></chaldalFaq>
  </div>
</template>
<script>
import Landing from '../components/chaldal/Landing.vue'
import Section2nd from '../components/chaldal/Section2nd.vue';
import Section3rd from '../components/chaldal/Section3rd.vue';
import Section4th from '../components/chaldal/Section4th.vue';
import Section5th from '../components/chaldal/Section5th.vue';
import Section6th from '../components/chaldal/Section6th.vue';
import Section7th from '../components/chaldal/Section7th.vue';
import Section8th from '../components/chaldal/Section8th.vue';
import chaldalFaq from '../components/faq/chaldalFaq.vue';

export default {
  components: { Landing, Section2nd, Section3rd, Section4th, Section6th, Section7th, Section8th, Section5th,chaldalFaq},

  created() { this.Loaded();
  }


}



</script>
<style scoped>

</style>
